// extracted by mini-css-extract-plugin
module.exports = {"popper":"wrapper_popper__8Vu75","popper__opened":"wrapper_popper__opened__mT_As"};